import React from 'react'
import ChartRadar from './ChartRadar'
import ChartRadarCohortMultiple from './ChartRadarCohortMultiple'
import styled from 'styled-components'
import ChartRadarSingle from './ChartRadarSingle'

const WrapComparision = styled.div`
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  .comparision-header {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 10px;
    span {
      width: 9px;
      height: 9px;
      background-color: #17B26A;
      border-radius: 50%;
    }
    h1 {
      font-size: 18px;
      font-weight: 600;
      line-height: 28px;
      color: #101828;
    }
  }
`

const ScoreComparision = (props) => {
  const { type } = props;
  
  const chartSwitch = (type) => {
    switch (type) {
      case "multiplel-cohort":
        return <ChartRadarCohortMultiple {...props} />;
      case "single-cohort":
        return <ChartRadarSingle {...props}/>;
      default:
        return <ChartRadar {...props} />;
    }
  }

  return (
    <WrapComparision>
      <div className="comparision-header">
        <span></span>
        <h1>Domain Average Score Comparison</h1>
      </div>
      {chartSwitch(type)}
    </WrapComparision>
  )
}

export default ScoreComparision
